import { CircularProgress, Fade } from '@mui/material';
import Box from '@mui/material/Box';

interface LoadingOverlayProps {
  loading: boolean;
  zIndex?: number;
  progressSize?: number | string;
  /**
   * Render only the dark overlay without the centered spinner. Used where the
   * spinner is shown elsewhere (e.g. a sticky header) so it stays visible even
   * when the overlaid area is scrolled out of view.
   */
  hideProgress?: boolean;
  /**
   * Fade-in duration. The default suits a full-view loader, where a slow ramp
   * keeps a fast load from flashing. Lower it where the overlay is direct
   * feedback for something the user just did — at 350ms the overlay is still
   * near-invisible ~150ms in, which reads as a lag before anything happens.
   */
  fadeTimeout?: number;
}
const LoadingOverlay = ({
  loading,
  zIndex = 100,
  progressSize = 40,
  hideProgress = false,
  fadeTimeout = 350
}: LoadingOverlayProps) => {
  return loading ? (
    <Fade in={loading} timeout={fadeTimeout}>
      <Box
        width="100%"
        height="100%"
        display="flex"
        justifyContent="center"
        alignItems="center"
        position="absolute"
        top="0"
        left="0"
        bgcolor="rgba(0, 0, 0, 0.1)"
        zIndex={zIndex}
      >
        {!hideProgress && <CircularProgress size={progressSize} />}
      </Box>
    </Fade>
  ) : null;
};

export default LoadingOverlay;
